import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import {
  OrderBuyerQuery,
  OrderBuyerData,
  BusinessQuery,
  BusinessData,
  gamesQuery,
  OrderUnpaidData,
  gamesData,
  OrderBuyerdetailData,
  OrderBuyerDisputeQuery,
  OrderBuyerCancelQuery,
  OrderBuyerGetcoinsPrepareQuery,
  RobloxStartTrading,
  RobloxStartTradingVO,
  RobloxGetItemsAndVO,
  RobloxSendItemListVO,
  RobloxRobloxUserInfoVO
} from '@/api/member/buyer-order/types';
import { OrderSellerDisputeData } from '@/api/member/sold-order/types';
/**
 * 获取买家待支付订单列表
 */
export const getOrderBuyerUnpaidList = (query?: any): AxiosPromise<OrderUnpaidData[]> => {
  return request({
    url: '/api/order/buyer/unpaid/list',
    method: 'get',
    params: query
  });
};
/**
 * 获取买家订单列表
 */
export const getOrderBuyerList = (query?: OrderBuyerQuery): AxiosPromise<OrderBuyerData[]> => {
  return request({
    url: '/api/order/buyer/list',
    method: 'get',
    params: query
  });
};

/**
 * 获取业务列表
 */
export const getBusinessByType = (query?: BusinessQuery): AxiosPromise<BusinessData[]> => {
  return request({
    url: '/product/product-common/getBusinessByType',
    method: 'get',
    params: query
  });
};

/**
 * 获取游戏列表
 */
export const getAllEntityByPage = (query?: gamesQuery): AxiosPromise<gamesData[]> => {
  return request({
    url: '/product/product-common/getAllEntityByPage',
    method: 'get',
    params: query
  });
};

/**
 * 订单详情
 */
export const getOrderBuyerdetail = (query: string | number): AxiosPromise<OrderBuyerdetailData> => {
  return request({
    url: '/order/order/buyer/detail/' + query,
    method: 'get'
  });
};

/**
 * 查询发货信息
 */
export const getOrderBuyerDeliveryInfo = (query: {
  orderId: string | number;
}): AxiosPromise<{
  deliveryInfo?: string;
  deliveryProof?: Array<string>;
  deliveryRemark?: string;
}> => {
  return request({
    url: '/api/order/buyer/delivery/info',
    method: 'get',
    params: query
  });
};

/**
 * 买家取消订单原因的列表
 */
export const getBuyerCancelReasonList = (): AxiosPromise<{ code: number; name: string }[]> => {
  return request({
    url: '/api/order/buyer/cancel/reason/list',
    method: 'get'
    // params: query
  });
};

/**
 * 买家发起争议原因的列表
 */
export const getBuyerDisputeReasonList = (): AxiosPromise<{ code: number; name: string }[]> => {
  return request({
    url: '/api/order/buyer/dispute/reason/list',
    method: 'get'
    // params: query
  });
};

/**
 * 买家取消争议
 */
export const getOrderBuyerDisputeCancel = (data: { orderId: string | number }): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/dispute/cancel',
    method: 'post',
    data
  });
};

/**
 * 买家取消争议退款
 */
export const getBuyerDisputeCancel = (data: { orderId: string | number }): AxiosPromise<boolean> => {
  return request({
    url: '/order/order/buyer/dispute/cancel',
    method: 'post',
    data
  });
};

/**
 * 买家取消退款
 */
export const getBuyerRefundCancel = (data: { orderId: string | number }): AxiosPromise<boolean> => {
  return request({
    url: '/order/order/buyer/refund/cancel',
    method: 'post',
    data
  });
};

/**
 * 买家发起争议
 */
export const getOrderBuyerDispute = (data: OrderBuyerDisputeQuery): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/dispute',
    method: 'post',
    data
  });
};

/**
 * 买家取消订单
 */
export const getOrderBuyerCancel = (data: OrderBuyerCancelQuery): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/cancel',
    method: 'post',
    data
  });
};

/**
 * 争议卖家拒绝后，买家处理
 */
export const getOrderBuyerDisputeConfirm = (data: { orderId: string | number; result: number }): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/dispute/confirm',
    method: 'post',
    data
  });
};

/**
 * 提币(填写EA账号信息
 */
export const getOrderBuyerGetCoins = (data: {
  password: string;
  account: string;
  backCode1: string;
  backCode2: string;
  backCode3: string;
  backCode4: string;
  platId?: string;
}): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/getcoins',
    method: 'post',
    data
  });
};

/**
 * 买家确认收货
 */
export const getOrderBuyerConfirm = (data: { orderId: string | number }): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/confirm',
    method: 'post',
    data
  });
};

/**
 * 允许提币的准备页面
 */
export const getcoinsPrepare = (data: { orderIds: string[] }): AxiosPromise<OrderBuyerGetcoinsPrepareQuery> => {
  return request({
    url: '/api/order/buyer/getcoins/prepare',
    method: 'post',
    data
  });
};

/**
 * 提币验号结果查询
 */
export const getOrderBuyerGetcoinsResult = (query: {
  orderId: string | number | string[];
}): AxiosPromise<{
  status?: number;
  message?: string;
  repeatFlag?: boolean;
}> => {
  return request({
    url: '/api/order/buyer/getcoins/result',
    method: 'get',
    params: query
  });
};

// 允许提币的相似订单
export const getorderBuyerGetcoinsList = (query: {
  orderId: string | number;
}): AxiosPromise<{ productName: string; orderId: string; platName: string; coins: number; getCoinFlag: number }[]> => {
  return request({
    url: '/api/order/buyer/getcoins/list',
    method: 'get',
    params: query
  });
};

/**
 * C端文件上传
 */
export const getCossUpload = (
  data: FormData
): AxiosPromise<{
  url: string;
  fileName: string;
  ossId: string;
  path: string;
  fileSuffix: string;
}> => {
  return request({
    url: '/resource/app/oss/upload',
    method: 'post',
    data
  });
};

/**
 * 买家争议详情
 */
export const getOrderBuyerDisputeDetai = (disputeId: string): AxiosPromise<OrderSellerDisputeData> => {
  return request({
    url: '/api/order/buyer/dispute/detail',
    method: 'get',
    params: { disputeId }
  });
};

// 创建会话
export const chatCreateConversation = (data: {
  orderId?: string;
  productName?: string;
  orderNumber?: string;
  sellerId?: string;
  uid?: string;
  type?: number;
}): AxiosPromise<string> => {
  return request({
    url: '/member/chat/createConversation',
    method: 'post',
    data
  });
};

// 首次评价
export const orderBuyerReviewFirst = (data: { orderId?: string; score?: number; content?: string }): AxiosPromise => {
  return request({
    url: '/api/order/buyer/review',
    method: 'post',
    data
  });
};

// 修改评价
export const orderBuyerReviewChange = (data: { orderId?: string; score?: number; content?: string }): AxiosPromise<boolean> => {
  return request({
    url: '/api/order/buyer/review',
    method: 'put',
    data
  });
};

// 获取订单是否超时
export const transactionExpired = (orderId?: string): AxiosPromise<number> => {
  return request({
    url: `/api/order/buyer/transaction/expired/${orderId}`,
    method: 'get'
  });
};
// 提币转换，换代使用
// POST /order/order/buyer/getcoins/transfer
// 接口ID：346998899
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-346998899
export const orderCoinsTransfer = (data: { orderIds: string[] }) => {
  return request({
    url: '/api/order/buyer/getcoins/transfer',
    method: 'post',
    data
  });
};

//开始交易（检查是否添加好友）
export const robloxStartTrading = (data: RobloxStartTrading): AxiosPromise<RobloxStartTradingVO> => {
  return request({
    url: '/order/order/roblox/startTrading',
    method: 'post',
    data
  });
};

//get item 确定装备订单列表
export const robloxGetItems = (orderIdList?: string[]): AxiosPromise<RobloxGetItemsAndVO> => {
  return request({
    url: '/order/order/roblox/getItems',
    method: 'post',
    data: { orderIdList }
  });
};

//确认Roblox用户
export const robloxConfirmRobloxUserInfo = (query: RobloxGetItemsAndVO): AxiosPromise<{ homepage: string }> => {
  return request({
    url: '/order/order/roblox/confirmRobloxUserInfo',
    method: 'post',
    data: query
  });
};

// roblox派单列表
export const robloxSendItemList = (sendId?: string): AxiosPromise<RobloxSendItemListVO[]> => {
  return request({
    url: `/order/order/roblox/sendItemList`,
    method: 'get',
    params: { sendId }
  });
};

// 获取Roblox用户信息
export const robloxRobloxUserInfo = (data?: RobloxGetItemsAndVO): AxiosPromise<RobloxRobloxUserInfoVO> => {
  return request({
    url: `/order/order/roblox/robloxUserInfo`,
    method: 'get',
    params: data
  });
};

// get items list 获取订单列表
export const robloxItemList = (orderId?: string): AxiosPromise<RobloxSendItemListVO[]> => {
  return request({
    url: '/order/order/roblox/itemList',
    method: 'get',
    params: { orderId }
  });
};

// 再来一单跳转
export const getOrderRepurchaseInfo = (params: {
  businessId?: string;
  gameId?: string;
  offerId?: string;
}): AxiosPromise<{ url: string }> => {
  return request({
    url: '/product/urlMapping/game-service/getOrderRepurchaseInfo',
    method: 'get',
    params
  });
};
